export default {
  inject: ['load'],
  data() {
    return {
      allResuscitationTypesForOther: [],
      resuscitationType: null,
    };
  },
  methods: {
    getListOfResuscitationTypesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllResuscitationTypes').then(() => {
        if (this.$store.state.resuscitationTypeModule.successFlag) {
          this.allResuscitationTypesForOther =
            this.$store.state.resuscitationTypeModule.allResuscitationTypes;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.resuscitationTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfResuscitationTypesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getResuscitationTypeFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getResuscitationType', id).then(() => {
        if (this.$store.state.resuscitationTypeModule.successFlag) {
          this.resuscitationType = this.$store.state.resuscitationTypeModule.resuscitationType;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.resuscitationTypeModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getResuscitationTypeFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.resuscitationTypeModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
